import { render, staticRenderFns } from "./BrakediscDetail.vue?vue&type=template&id=5d1c9970&scoped=true"
import script from "./BrakediscDetail.vue?vue&type=script&lang=js"
export * from "./BrakediscDetail.vue?vue&type=script&lang=js"
import style0 from "./BrakediscDetail.vue?vue&type=style&index=0&id=5d1c9970&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1c9970",
  null
  
)

export default component.exports